// actionsReducer.js

import * as types from '../constants/ActionTypes-answer';

// Definir el estado inicial
const initialState = {
  tableAnswer: [], // Inicialmente vacío
  loading: false,
  error: null,
};

// Definir el reducer
const actionsAnswerReducer = (state = initialState, action) => {
    if (action.reducer_type === 'reducer_answer') {    
        switch (action.type) {
            case types.SET_ANSWERS:
            return {
                ...state,
                tableAnswer: action.payload,
            };        
            case types.FETCH_ANSWERS:
            return state; 
            case types.ADD_ANSWER_ITEM:
            return {
                ...state,
                tableAnswer: [...state.tableAnswer, action.payload],
            };
            case types.ADD_DOCUMENT_FLAG:
            return {
              ...state,
              tableAnswer: state.tableAnswer.map(item => {
                  if (item.id === action.payload) {
                      return {
                          ...item,
                          has_docs: true
                      };
                  }
                  return item;
              })
          };
            case types.SAVE_ANSWER_ITEM:
            return {
                ...state,
                tableAnswer: state.tableAnswer.map(item =>
                item.id === action.payload.id ? action.payload : item
                ),
            };
            case types.DELETE_ANSWER_ITEM:
            return {
                ...state,
                tableAnswer: state.tableAnswer.filter(item => item.id !== action.payload),
            };        
            default:
            return state;
        }
    }
    return state;
};

export default actionsAnswerReducer;